import { render, staticRenderFns } from "./CardLeft.vue?vue&type=template&id=2ccd8022&scoped=true&"
import script from "./CardLeft.vue?vue&type=script&lang=js&"
export * from "./CardLeft.vue?vue&type=script&lang=js&"
import style0 from "./CardLeft.vue?vue&type=style&index=0&id=2ccd8022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd8022",
  null
  
)

export default component.exports